// src/components/Hero.js
import React from "react";
import "../styles/Hero.css";
import heroImage from "../assets/hero-background.png";

const Hero = () => {
  const scrollToJourney = () => {
    const journeySection = document.getElementById("journey-section");
    if (journeySection) {
      journeySection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className="newhome-hero"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="newhome-hero-content">
        <h1>BE SMART WITH YOUR VOTE</h1>
        <p>So you can be Confident in your Choice</p>
        <button className="newhome-get-started-btn" onClick={scrollToJourney}>
          Get Started
        </button>
      </div>
    </header>
  );
};

export default Hero;
